import actions from '../actions';
import { ASYNC_FETCH_INITIAL_STATE, makeAsyncFetchReducer, makeReducer } from '../utils';

export const INITIAL_STATE = {
  newuser: ASYNC_FETCH_INITIAL_STATE,
  update : ASYNC_FETCH_INITIAL_STATE,
  remove : ASYNC_FETCH_INITIAL_STATE,
  user   : ASYNC_FETCH_INITIAL_STATE,
};

const reducer = makeReducer({
  initialState: INITIAL_STATE,
  reducers    : {
    ...makeAsyncFetchReducer({
      key    : 'create',
      init   : actions.newuser.create.type,
      success: actions.newuser.createSuccess.type,
      error  : actions.newuser.createError.type,
    }),
    ...makeAsyncFetchReducer({
      key    : 'update',
      init   : actions.newuser.update.type,
      success: actions.newuser.updateSuccess.type,
      error  : actions.newuser.updateError.type,
    }),
    ...makeAsyncFetchReducer({
      key    : 'remove',
      init   : actions.newuser.remove.type,
      success: actions.newuser.removeSuccess.type,
      error  : actions.newuser.removeError.type,
    }),
    ...makeAsyncFetchReducer({
      key    : 'fetch',
      init   : actions.newuser.fetch.type,
      success: actions.newuser.fetchSuccess.type,
      error  : actions.newuser.fetchError.type,
    }),
  },
});

export default reducer;
